<template>
    <div v-if="gnbName == 'gnb'" :class="gnbName + '-wrap'">
        <ul :class="[gnbName, gnbClass]">
            <template v-for="(item, index) in gnbs.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )">
                <template v-if="item.accessShow == true ? accessToken : true">
                    <li v-if="!item.children" :key="index" :class="[gnbName + '__item ', item.className ? item.className : '']">
                        <a v-if="item.href" :href="item.href" target="_blank" :class="gnbName + '__link'">{{ item.title }}</a>
                        <router-link v-else :to="item.path" :class="gnbName + '__link'">
                            <h2>{{ item.title }}</h2>
                        </router-link>
                        <component :is="lnbTag" class="lnb--empty"></component>
                    </li>

                    <li v-else :key="index" :class="[gnbName + '__item ', item.className ? item.className : '']">
                        <a v-if="item.href" :href="item.href" target="_blank" :class="gnbName + '__link ' + gnbName + '__link--toggle'">{{ item.title }}</a>
                        <router-link v-else :to="item.path" :class="gnbName + '__link ' + gnbName + '__link--toggle'">
                            <h2>{{ item.title }}</h2>
                        </router-link>

                        <component :is="lnbTag">
                            <li v-for="(child, index) in item.children.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )" :key="index">
                                <a v-if="child.href" :href="child.href" target="_blank">{{ child.title }}</a>
                                <router-link v-else :to="child.path" class="white-pre-wrap">{{ child.title }}</router-link>
                            </li>
                        </component>
                    </li>
                </template>
            </template>
        </ul>
    </div>
    <div v-else-if="gnbName == 'gnb-mo'" :class="gnbName + '-wrap'">
        <ul :class="[gnbName, gnbClass]">
            <template v-for="(item, index) in gnbs.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )">
                <template v-if="item.accessShow == true ? accessToken : true">
                    <li v-if="!item.children" :key="index" :class="[gnbName + '__item ', item.className ? item.className : '']">
                        <a v-if="item.href" :href="item.href" target="_blank" :class="gnbName + '__link'">{{ item.title }}</a>
                        <router-link v-else :to="item.path" :class="gnbName + '__link'">
                            <h2>{{ accessToken }}{{ item.title }}</h2>
                        </router-link>
                    </li>

                    <li v-else :key="index" :class="[gnbName + '__item ', item.className ? item.className : '']">
                        <a v-if="item.href" :href="item.href" target="_blank" :class="gnbName + '__link ' + gnbName + '__link--toggle'"> {{ accessToken }}{{ item.title }} </a>
                        <router-link v-else :to="item.path" :class="gnbName + '__link ' + gnbName + '__link--toggle'">
                            <h2>{{ item.title }}</h2>
                        </router-link>
                        <v-btn class="v-btn--text-fit" :class="gnbName + '__arrow'">
                            <icon-arrow-primary size="x-small" direction="down" />
                        </v-btn>

                        <ul :class="gnbName + '__sub'">
                            <template v-for="(child, index) in item.children.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )">
                                <li v-if="!child.children" :key="index" :class="gnbName + '__sub-item'">
                                    <a v-if="child.href" :href="child.href" target="_blank" :class="gnbName + '__sub-link'">{{ child.title }}</a>
                                    <router-link v-else :to="child.path" :class="gnbName + '__sub-link'">
                                        {{ child.title }}
                                    </router-link>
                                </li>

                                <li v-else :key="index" :class="gnbName + '__sub-item'">
                                    <a v-if="child.href" :href="child.href" target="_blank" :class="gnbName + '__sub-link ' + gnbName + '__sub-link--toggle'">{{ child.title }}</a>
                                    <router-link v-else :to="child.path" :class="gnbName + '__sub-link ' + gnbName + '__sub-link--toggle'">{{ child.title }}</router-link>

                                    <ul :class="gnbName + '__sub'">
                                        <li v-for="grandChild in child.children.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )" :key="grandChild.title" :class="gnbName + '__sub-item'">
                                            <a v-if="grandChild.href" :href="grandChild.href" target="_blank" :class="gnbName + '__sub-link'">{{ grandChild.title }}</a>
                                            <router-link v-else :to="grandChild.path" :class="gnbName + '__sub-link'">{{ grandChild.title }}</router-link>
                                        </li>
                                    </ul>
                                </li>
                            </template>
                        </ul>
                    </li>
                </template>
            </template>
        </ul>
    </div>
    <div v-else-if="gnbName == 'sitemap-menu'" :class="gnbName + '-wrap'">
        <ul :class="[gnbName, gnbClass]">
            <template v-for="(item, index) in gnbs.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )">
                <li v-if="!item.children" :key="index" :class="[gnbName + '__item ', item.className ? item.className : '']">
                    <a v-if="item.href" :href="item.href" target="_blank" :class="gnbName + '__link'">{{ item.title }}</a>
                    <router-link v-else :to="item.path" :class="gnbName + '__link'">
                        <h2>{{ item.title }}</h2>
                    </router-link>
                </li>

                <li v-else :key="index" :class="[gnbName + '__item ', item.className ? item.className : '']">
                    <a v-if="item.href" :href="item.href" target="_blank" :class="gnbName + '__link ' + gnbName + '__link--toggle'">
                        {{ item.title }}
                    </a>
                    <router-link v-else :to="item.path" :class="gnbName + '__link ' + gnbName + '__link--toggle'">
                        <h2>{{ item.title }}</h2>
                    </router-link>

                    <ul :class="gnbName + '__sub'">
                        <template v-for="(child, index) in item.children.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )">
                            <li v-if="!child.children" :key="index" :class="gnbName + '__sub-item'">
                                <a v-if="child.href" :href="child.href" target="_blank" :class="gnbName + '__sub-link'">{{ child.title }}</a>
                                <router-link v-else :to="child.path" :class="gnbName + '__sub-link'">
                                    {{ child.title }}
                                </router-link>
                            </li>

                            <li v-else :key="index" :class="gnbName + '__sub-item'">
                                <a v-if="child.href" :href="child.href" target="_blank" :class="gnbName + '__sub-link ' + gnbName + '__sub-link--toggle'">{{ child.title }}</a>
                                <router-link v-else :to="child.path" :class="gnbName + '__sub-link ' + gnbName + '__sub-link--toggle'">{{ child.title }}</router-link>
                                <v-btn class="v-btn--text-fit" :class="gnbName + '__arrow'">
                                    <slot name="arrow" />
                                </v-btn>

                                <ul :class="gnbName + '__sub'">
                                    <li v-for="grandChild in child.children.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )" :key="grandChild.title" :class="gnbName + '__sub-item'">
                                        <a v-if="grandChild.href" :href="grandChild.href" target="_blank" :class="gnbName + '__sub-link'">{{ grandChild.title }}</a>
                                        <router-link v-else :to="grandChild.path" :class="gnbName + '__sub-link'">{{ grandChild.title }}</router-link>
                                    </li>
                                </ul>
                            </li>
                        </template>
                    </ul>
                </li>
            </template>
        </ul>
    </div>
    <div v-else-if="gnbName == 'sub-tab'" :class="gnbName + '-wrap'">
        <v-container>
            <template v-for="item in gnbs.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )">
                <template v-if="item.title == itemTitle">
                    <component :is="tabsTag" :key="item.title" v-bind="{ ...tabsAttrs }">
                        <component :is="tabTag" v-for="child in item.children.filter(gnb => gnb.onDisplay === undefined || gnb.onDisplay )" :key="child.title" v-bind="tabAttrs" :to="child.path" exact-path :class="[tabActive == child.title ? 'v-tab--active' : '', tabAttrs.class]">{{ child.title.replaceAll('\r\n','') }}</component>
                    </component>
                </template>
            </template>
        </v-container>
    </div>
</template>

<script>
import api from "@/api";
import { attrs_tabs_common } from "@/assets/variables";

import Lnb from "@/components/publish/styles/headers/lnb.vue";
import ULnbToplineBorder from "@/components/publish/styles/headers/u-lnb-topline-border.vue";
import ULnbAllFilled from "@/components/publish/styles/headers/u-lnb-all-filled.vue";
import ULnbAllBorder from "@/components/publish/styles/headers/u-lnb-all-border.vue";
import ULnbAllOpacityBlack from "@/components/publish/styles/headers/u-lnb-all-opacity-black.vue";
import IconArrowPrimary from "@/components/publish/parents/icons/icon-arrow-primary.vue";

import UTabsBorder from "@/components/publish/styles/tabs/u-tabs-border.vue";
import UTabsDot from "@/components/publish/styles/tabs/u-tabs-dot.vue";
import UTabsFilled from "@/components/publish/styles/tabs/u-tabs-filled.vue";
import UTabsSlider from "@/components/publish/styles/tabs/u-tabs-slider.vue";
import UTabButton from "@/components/publish/styles/tabs/u-tab-button.vue";
import UTabDot from "@/components/publish/styles/tabs/u-tab-dot.vue";
import UTabFilled from "@/components/publish/styles/tabs/u-tab-filled.vue";
import UTabPunch from "@/components/publish/styles/tabs/u-tab-punch.vue";

export default {
    props: {
        gnbName: String,
        gnbClass: String,
        lnbTag: String,

        itemTitle: String,
        tabActive: String,
        tabsTag: String,
        tabsAttrs: { type: Object, default: () => ({}) },
        tabTag: String,
        tabAttrs: { type: Object, default: () => ({}) },
    },
    components: {
        Lnb,
        ULnbToplineBorder,
        ULnbAllFilled,
        ULnbAllBorder,
        ULnbAllOpacityBlack,
        IconArrowPrimary,

        UTabsBorder,
        UTabsDot,
        UTabsFilled,
        UTabsSlider,
        UTabButton,
        UTabDot,
        UTabFilled,
        UTabPunch,
    },
    data: function () {
        return {
            setting: { onReview: false },
            attrs_tabs_common,
        };
    },
    methods: {
        async init(){
            var { setting } = await api.v1.easyleg.settings.get();
            this.setting = setting;
        }
    },
    mounted(){
        this.init();
    },
    computed: {
        gnbs(){
            return [
                {
                    title: "편안하지흉부외과",
                    path: "/introduction",
                    children: [
                        {
                            title: "편안하지 소개",
                            path: "/introduction",
                        },
                        {
                            title: "의료진 소개",
                            path: "/introduction/team",
                        },
                        {
                            title: "병원 둘러보기",
                            path: "/introduction/panorama",
                        },
                        {
                            title: "고객리뷰",
                            path: "/review",
                            onDisplay: this.setting.onReview,
                        },
                        {
                            title: "진료시간/오시는 길",
                            path: "/introduction/information",
                        },
                    ],
                },
                {
                    title: "하지정맥류",
                    path: "/varicose",
                    children: [
                        {
                            title: "하지정맥류란?",
                            path: "/varicose",
                        },
                        {
                            title: "나도 하지정맥류?",
                            path: "/varicose/self-diagnosis",
                        },
                        {
                            title: "하지정맥류 치료기준\r\n(조건)",
                            path: "/varicose/standards",
                        },
                        {
                            title: "하지정맥류 치료원칙",
                            path: "/varicose/principles",
                        },
                    ],
                },
                {
                    title: "하지정맥류 비수술",
                    path: "/non-surgical/stockings",
                    children: [
                        {
                            title: "압박스타킹",
                            path: "/non-surgical/stockings",
                        },
                        {
                            title: "경구약\r\n(정맥순환개선제)",
                            path: "/non-surgical/drugs",
                        },
                        {
                            title: "혈관경화요법\r\n(주사치료)",
                            path: "/non-surgical/sclerotherapy",
                        },
                    ],
                },
                {
                    title: "하지정맥류 수술",
                    path: "/surgery/clarivein",
                    children: [
                        {
                            title: "클라리베인",
                            path: "/surgery/clarivein",
                        },
                        {
                            title: "플레보그립",
                            path: "/surgery/flebogrif",
                        },
                        {
                            title: "베나실",
                            path: "/surgery/venaseal",
                        },
                        {
                            title: "고주파",
                            path: "/surgery/rfa",
                        },
                        {
                            title: "레이저",
                            path: "/surgery/laser",
                        },
                        {
                            title: "발거술",
                            path: "/surgery/stripping",
                        },
                    ],
                },
                {
                    title: "치료비용 안내",
                    path: "/cost",
                    children: [
                        {
                            title: "편안하지흉부외과\r\n수술비 원칙",
                            path: "/cost",
                        },
                    ],
                },
                // {
                //     title: "게시판",
                //     path: "/center/notice",
                //     children: [
                //         {
                //             title: "공지사항",
                //             path: "/center/notice",
                //         },
                //         {
                //             title: "자주 묻는 질문",
                //             path: "/center/faq",
                //         },
                //         {
                //             title: "기본게시판",
                //             path: "/board/default-board",
                //         },
                //     ],
                // },
                // {
                //     title: "폼메일",
                //     path: "/default-form",
                // },
                // {
                //     title: "약관",
                //     path: "/privacy-policy",
                //     children: [
                //         {
                //             title: "개인정보처리방침",
                //             path: "/privacy-policy",
                //         },
                //         {
                //             title: "이용약관",
                //             path: "/terms-use",
                //         },
                //     ],
                // },
                // {
                //     title: "마이페이지",
                //     path: "/mypage/question",
                //     className: "d-xl-none",
                //     accessShow: true,
                //     children: [
                //         {
                //             title: "1:1 문의",
                //             path: "/mypage/question",
                //         },
                //         {
                //             title: "개인정보",
                //             path: "/mypage/myinfo",
                //         },
                //     ],
                // },
            ];
        } ,
        accessToken() {
            return this.$store.state.accessToken;
        },
    },
};
</script>

<style lang="scss" scoped>
// gnb
.gnb {
    display: none;
}
@media (min-width: 1200px) {
    .gnb {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        width: var(--gnb-width);
        &__item {
            position: relative;
            width: var(--gnb-item-width);
        }
        &__link {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            min-height: var(--header-body-height);
            font-size: var(--gnb-font-size);
            font-weight: var(--gnb-font-weight);
            color: var(--v-grey-darken4);
            padding: var(--gnb-padding-y) var(--gnb-padding-x);
            -webkit-transition: all ease-out 0.2s;
            -ms-transition: all ease-out 0.2s;
            transition: all ease-out 0.2s;
        }
        h2 {
            font-size: inherit;
        }

        // light
        &--light {
            ::v-deep {
                .gnb__link {
                    color: #fff;
                }
            }
        }
    }
}

// gnb-mo
.gnb-mo {
    h2 {
        font-size: inherit;
        font-weight: inherit;
        color: inherit;
    }
    &__item {
        position: relative;
        &.open {
            .gnb-mo__sub {
                height: auto;
                opacity: 1;
                visibility: visible;
                padding: 8px 0;
            }
        }
    }
    &__link {
        position: relative;
        display: flex;
        align-items: center;
        height: 54px;
        font-size: 1.4rem;
        padding: 0 var(--container-gutter);
    }
    &__link--toggle {
        padding-right: calc(var(--container-gutter) + 30px);
    }
    &__arrow {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        width: calc(var(--container-gutter) + 30px) !important;
        height: 54px !important;
        border-radius: 0 !important;
    }
    &__sub {
        height: 0;
        overflow: hidden;
        opacity: 0;
        visibility: hidden;
        transition: all ease-out 0.2s;
        .gnb-mo__sub {
            padding: 0 0 0 var(--container-gutter) !important;
        }
    }
    &__sub-link {
        display: flex;
        align-items: center;
        font-size: 1.4rem;
        padding: 6px var(--container-gutter);
    }
}

// sitemap-menu
.sitemap-menu {
    h2 {
        font-size: inherit;
        font-weight: inherit;
        color: inherit;
    }
    &__sub-item {
        .sitemap-menu__sub {
            height: 0;
            margin: 0;
            overflow: hidden;
            opacity: 0;
            visibility: hidden;
            transition: all ease-out 0.2s;
        }

        &.open {
            .sitemap-menu {
                &__sub {
                    height: auto;
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
    }
}
</style>
